const mapLocation = location => ({
  id: location.id,
  name: location.name,
})

const mapStoreInventoryLocations = entry => ({
  store_id: entry.store_id,
  locations: entry.locations.map(mapLocation),
})

export const transformResponseMerchantInventoryLocations = response => response.map(mapStoreInventoryLocations)
